import AuthlessA5PrintPage from "@/components/common-receipt/AuthlessA5PrintPage";
import {
  yearlyLedgerEntryA5Props,
  type YearlyLedgerPrintRow,
} from "./yearly-ledger-entry-print-content";

const YearlyLedgerEntryPrint = () => (
  <AuthlessA5PrintPage<YearlyLedgerPrintRow>
    location="yearly-ledger"
    buildId={(routeId) => `print/${routeId}`}
    toProps={yearlyLedgerEntryA5Props}
  />
);

export default YearlyLedgerEntryPrint;
